import { useOutletContext } from "react-router-dom";
import { BuildList } from "../../components/BuildList";
import type { ProjectContextData } from "./ProjectLayout";

export function ProjectBuildsPage() {
  const { builds, deployJobs, storefronts } = useOutletContext<ProjectContextData>();

  return <BuildList builds={builds} deployJobs={deployJobs} storefronts={storefronts} />;
}
